import { inject, Injectable } from "@angular/core";
import { AttachmentsStore } from "./store/attachments";
import { DeclarationsStore } from "./store/declarations";
import { GeneralDetailsStore } from "./store/general-details";
import { ProductsStoreService } from "./store/products";
import { RequestDetailsStore } from "./store/request-details";
import { ApplicantDetailsStore } from "./store/applicant-details";
import { GeneralStore } from "./store/general";
import { RequestApprovalTypeDetailsStore } from "./store/approval-type-details-store";
import { MCAttachmentUploadStoreService, MCFormStateService } from "@maslul/common-services";

@Injectable({
    providedIn: 'root',
})
export class RequestService {

    private mcFormStateService = inject(MCFormStateService);
    private requestApprovalTypeDetailsStore = inject(RequestApprovalTypeDetailsStore);
    private generalStore = inject(GeneralStore);
    private applicantDetailsStore = inject(ApplicantDetailsStore);
    private generalDetailsStore = inject(GeneralDetailsStore);
    private productsStoreService = inject(ProductsStoreService);
    private requestDetailsStore = inject(RequestDetailsStore);
    private attachmentsStore = inject(AttachmentsStore);
    private declarationsStore = inject(DeclarationsStore);
    private attachmentUploadStore = inject(MCAttachmentUploadStoreService);

    initMyImportFormState() {
        this.mcFormStateService.setFormState('isMyImport', true);
    }

    clearRequestStore() {
        this.requestApprovalTypeDetailsStore.initStore();
        this.generalStore.initStore();
        this.applicantDetailsStore.initStore();
        this.generalDetailsStore.initStore();
        this.productsStoreService.initStore();
        this.requestDetailsStore.initStore();
        this.attachmentsStore.initStore();
        this.declarationsStore.initStore();
        this.attachmentUploadStore.initStore();
        this.initMyImportFormState();
    }
}